// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent---E1Dei","modalFooter":"modalFooter---lfDnX"};